export const ROUTES = {
  SELECT_SOLUTIONS: 'select-solutions',
  VIEW_SUMMARY: 'view-summary',
  SELECT_CHALLENGES: 'select-challenges',
  SOLUTION_SELECTION: 'solution-selection',
  WORKFLOW: 'workflow',
  DIAGNOSIS_COMPLETE: 'diagnosis-complete',
};

export const PARAMS = {
  ExternalId: 'eid',
  SessionId: 'sid',
  DiagnosisId: 'diagnosisId',
  Source: 'source',
};

export const LOCAL_VARS = {
  SelectedPSL: 'SelectedPSL',
};

export const SOURCE = {
  VDR: 'vdr',
  DEFAULT: '',
};
